import { createGlobalStyle } from 'styled-components';

import { BDSColor } from '../tokens/color';
const generateCSSVariables = (colors, prefix = '--') => {
  const variables = [];
  const traverse = (obj, path) => {
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'object') {
        traverse(value, [...path, key]);
      } else {
        const variableName = `${prefix}${path.concat(key).join('-')}`;
        variables.push(`${variableName}: ${value};`);
      }
    }
  };
  traverse(colors, []);
  return variables.join('\n');
};
// CSS 변수를 :root에 적용하는 글로벌 스타일 정의
const cssVariables = generateCSSVariables(BDSColor);
export const ChatGlobalStyle = createGlobalStyle`
  :root {
    ${cssVariables}
  }

  html, body {
    &.dark {
      color: #fff;
      background: #111114;

      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus,
      input:-webkit-autofill:active {
        -webkit-text-fill-color: #fff;
        -webkit-box-shadow: 0 0 0px 1000px #262626 inset !important;
      }
    }
  }
`;
